(function () {
    'use strict';
    if (window.localStorage) {
        if (typeof localStorage.getItem("localStoragePlz") !== 'undefined' && localStorage.getItem("localStoragePlz") !== null) {
            $('.select-umkreis').val(localStorage.getItem('localStorageKm'));
            $('#plz').val(localStorage.getItem('localStoragePlz'));
        }
    }
    // the event needs to be run before slick is initialized
    $('#section-slider .site-container, #slider_content .site-container').on('init', function (event, slick, direction) {

        // check to see if there are one or less slides
        if (!($('#section-slider .site-container .slick-slide, #slider_content .site-container .slick-slide').length > 1)) {

            // remove arrows
            $('.arrow-prev, .arrow-next').hide();

        }

    });
    $('#section-slider .site-container, #slider_content .site-container').slick({
        dots: true,
        arrows: false,
        adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $('#section-page-content .site-container .slider').slick({
        infinite: true,
        dots: true,
        arrows: true,
        adaptiveHeight:false,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $('.arrow-prev').on('click', function() {
      $('#section-slider .site-container, #slider_content .site-container').slick('slickPrev');
    });

    $('.arrow-next').on('click', function() {
      $('#section-slider .site-container, #slider_content .site-container').slick('slickNext');
    });


    $(document).ready(function() {
        $('.site-header').on('click','#open-mobile-menu', function(e){
            e.preventDefault();
            $('#submenu-products').hide().removeClass("open-submenu");
            $('#submenu-about').hide().removeClass("open-submenu");
            $('#submenu-contact').hide().removeClass("open-submenu");

            $(this).addClass("open");
            if($('#submenu-mobile').hasClass("open-submenu")) {
                $(this).removeClass("open");
                $('#submenu-mobile').hide().removeClass("open-submenu");
            } else {
                $('#submenu-mobile').css('display','flex').addClass("open-submenu");
            }
        });

        //--------------------------------------------------------------------------------------
        $('.site-main-navigation').on('click','.open-submenu-products', function(e){
            e.preventDefault();
            $('#submenu-about').hide().removeClass("open-submenu");
            $('#submenu-contact').hide().removeClass("open-submenu");
            if($('#submenu-products').hasClass("open-submenu")) {
                $('#submenu-products').hide().removeClass("open-submenu");
            } else {
                $('#submenu-products').css('display','flex').addClass("open-submenu");
            }
        });

        $('.site-main-navigation').on('click','.open-submenu-contact', function(e){
            e.preventDefault();
            $('#submenu-about').hide().removeClass("open-submenu");
            $('#submenu-products').hide().removeClass("open-submenu");
            if($('#submenu-contact').hasClass("open-submenu")) {
                $('#submenu-contact').hide().removeClass("open-submenu");
            } else {
                $('#submenu-contact').css('display','flex').addClass("open-submenu");
            }
        });

        $('.site-main-navigation').on('click','.open-submenu-about', function(e){
            e.preventDefault();
            $('#submenu-contact').hide().removeClass("open-submenu");
            $('#submenu-products').hide().removeClass("open-submenu");
            if($('#submenu-about').hasClass("open-submenu")) {
                $('#submenu-about').hide().removeClass("open-submenu");
            } else {
                $('#submenu-about').css('display','flex').addClass("open-submenu");
            }
        });

        $(document).on({
            mouseenter: function () {
                $('#submenu-contact').css('display','flex').addClass("open-submenu");
                $('#submenu-about').hide().removeClass("open-submenu");
                $('#submenu-products').hide().removeClass("open-submenu");
            }
        }, ".open-submenu-contact");
        $(document).on({
            mouseenter: function () {
                $('#submenu-products').css('display','flex').addClass("open-submenu");
                $('#submenu-about').hide().removeClass("open-submenu");
                $('#submenu-contact').hide().removeClass("open-submenu");
            }
        }, ".open-submenu-products");
        $(document).on({
            mouseenter: function () {
                $('#submenu-about').css('display','flex').addClass("open-submenu");
                $('#submenu-contact').hide().removeClass("open-submenu");
                $('#submenu-products').hide().removeClass("open-submenu");
            }
        }, ".open-submenu-about");
        $(document).on({
            mouseleave: function () {
                $('#submenu-about').hide().removeClass("open-submenu");
                $('#submenu-contact').hide().removeClass("open-submenu");
                $('#submenu-products').hide().removeClass("open-submenu");
            }
        }, "#submenu-about, #submenu-contact, #submenu-products");
        //--------------------------------------------------------------------------------------

        $('#section-products .tabs').on('click','a', function(e){
            e.preventDefault();
            var _that = $(this);
            var tab = $(this).data("tab");
            _that.parent().siblings().removeClass('active');
            _that.parent().addClass('active');
            $('#' + tab).siblings().removeClass('active');
            $('#' + tab).addClass('active');
        });
    });

})();
